import { render } from "./Interviews.vue?vue&type=template&id=2ad5c43d"
import script from "./Interviews.vue?vue&type=script&lang=js"
export * from "./Interviews.vue?vue&type=script&lang=js"

import "./Interviews.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__